$(document).on('click', '.copy-trigger', function(e) {

  e.preventDefault();

  var $btn = $(this);
  var $text = $btn.find('span');
  var textToCopy = $btn.data('copy');

  if (!textToCopy) return;

  navigator.clipboard.writeText(textToCopy).then(function() {
    // --- 1. Visual Feedback on the Button ---
    var originalColor = $btn.css('color');
    $btn.css('color', '#22c55e'); // Success Green
    $text.text('Copied!');

    // --- 2. Trigger the Pretty Alert ---
    $('#notice_alert .alert--info .alert__message').text('Copied ID to clipboard');
    $('#notice_alert').fadeIn();

    // --- 3. Reset Button after 1.5 seconds ---
    setTimeout(function() {
      $btn.css('color', originalColor);
      $text.text(textToCopy); // This might need to be static text like "Copy ID" depending on your UI
    }, 1500);

    // Auto-hide Alert after 4 seconds
    setTimeout(function() {
      $('#notice_alert').fadeOut();
    }, 4000);

  }).catch(err => {
    console.error('Copy failed', err);
  });
});


$(document).on("turbolinks:load", () => {


    $('#select_payment_method').on('change', function () {
        $('#placeholder_button').hide();
        display_infos($(this).val());
    });

    // A method preselected by the server (ACH for auto-pay villages) shows
    // its section right away, as if it had been picked.
    if ($('#select_payment_method').val()) {
        $('#select_payment_method').trigger('change');
    }

    $('#stripeCreditCardButton').on('click', function() {
        initStripePayment();
    });

    $('#invoice_details_button').on('click', function() {
        $('#invoice_details_button').slideUp();
        $('#invoice_details').slideDown();
    });

    //filter_invoices_table("sent")


    $('#ctrl-show-by_status').on('change', function () {
        filter_invoices_table($(this).val());
    });
});

function display_infos(val) {
    if(val == "check") {
        $('#payment_information_check').show();
        $('#payment_information_creditcard').hide();
        $('#payment_information_ach').hide();
        $('#payment_ach_micropayments').hide();
        $('#payment_ach_form').hide();
    } else if(val == "ach") {
        $('#payment_information_check').hide();
        $('#payment_information_creditcard').hide();
        handle_ach();
    } else if(val == "creditcard") {
        $('#payment_information_check').hide();
        $('#payment_information_creditcard').show();
        $('#payment_information_ach').hide();
        $('#payment_ach_micropayments').hide();
        $('#payment_ach_form').hide();
    }
}

function handle_ach() {
    $ach_status = $('#ach_status').val();
    if (($ach_status == "Not defined") || ($ach_status == "")) {
        $('#payment_information_ach').show();
        $('#payment_ach_micropayments').hide();
        $('#payment_ach_form').hide();
        initStripeBankAccountNew();
    } else if($ach_status == "Not verified") {
        $('#payment_information_ach').hide();
        $('#payment_ach_micropayments').show();
        $('#payment_ach_form').hide();
    } else {
        $('#payment_information_ach').hide();
        $('#payment_ach_micropayments').hide();
        $('#payment_ach_form').show();
    }
    
}

function initStripePayment() {
    var pubKey = $("#stripe_publishable_key").val();
    var amount = parseInt($("#credit_card_amount").val());
    var handler = getStripeHandler(pubKey, amount, '#pay_invoice_credit_card');
    handler.open();
}

function initStripeBankAccountNew() {
    var pubKey = $("#stripe_publishable_key").val();
    var stripe = Stripe(pubKey);

    const form = document.getElementById("register_bank_account_form");
    const submitButton = document.getElementById("submit_bank_account");
    const submitLabel = submitButton.innerHTML;
    const errorBox = form.querySelector(".errors");

    function resetButton() {
      submitButton.disabled = false;
      submitButton.innerHTML = submitLabel;
    }

    function showError(message) {
      if (errorBox) {
        errorBox.textContent = message;
      } else {
        alert(message);
      }
      resetButton();
    }

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      event.stopPropagation();

      const mandateCheckbox = document.getElementById("ach_mandate_acceptance");
      if (!mandateCheckbox.checked) {
        alert("You must accept the ACH debit authorization to continue.");
        return;
      }

      if (errorBox) {
        errorBox.textContent = "";
      }
      submitButton.disabled = true;
      submitButton.innerHTML = "<i class='fa fa-spinner fa-spin'></i> Connecting your bank...";

      const clientSecret = document.getElementById("setup_intent_client_secret").value;
      const invoiceId = document.getElementById("invoice_id").value;
      const invoiceKey = document.getElementById("invoice_key").value;

      try {
        const collected = await stripe.collectBankAccountForSetup({
          clientSecret: clientSecret,
          params: {
            payment_method_type: 'us_bank_account',
            payment_method_data: {
              billing_details: {
                name: document.getElementById("account_holder_name").value,
                email: document.getElementById("stripe_customer_email").value, // required for microdeposits
              },
              us_bank_account: {
                account_holder_type: document.getElementById("account_holder_type").value,
              },
            },
            mandate_data: {
              customer_acceptance: {
                type: "online",
                online: {
                  ip_address: window.client_ip || undefined,
                  user_agent: navigator.userAgent,
                },
              },
            },
          },
        });

        if (collected.error) {
          throw collected.error;
        }

        // Closing the bank picker without choosing an account resolves with the
        // untouched SetupIntent rather than an error.
        if (collected.setupIntent.status !== "requires_confirmation") {
          resetButton();
          return;
        }

        const confirmed = await stripe.confirmUsBankAccountSetup(clientSecret);
        if (confirmed.error) {
          throw confirmed.error;
        }

        const setupIntent = confirmed.setupIntent;
        const paymentMethod = setupIntent.payment_method;
        const paymentMethodId = typeof paymentMethod === "string" ? paymentMethod : paymentMethod && paymentMethod.id;

        if (!paymentMethodId) {
          throw new Error("Your bank account could not be linked. Please try again.");
        }

        // Register the payment method before leaving the page. Confirming alone leaves it
        // attached to the SetupIntent only, which is invisible to the payment flow.
        const response = await fetch("/invoices/" + invoiceId + "/create_bank_account_from_fca?key=" + encodeURIComponent(invoiceKey), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          },
          body: JSON.stringify({ payment_method_id: paymentMethodId }),
        });

        const body = await response.json();
        if (!response.ok) {
          throw new Error(body.error || "We could not save your bank account. Please try again.");
        }

        // Microdeposit verification leaves the account attached but unusable until the
        // customer confirms the two amounts Stripe deposits.
        const result = setupIntent.status === "succeeded" ? "ach_mandate_accepted" : "ach_microdeposits_pending";
        window.location.href = body.redirect_url + "?result=" + result;
      } catch (err) {
        console.error(err);
        showError(err.message || "An unexpected error occurred. Please try again.");
      }
    });
}


function getStripeHandler(pubKey, amount, submit){

  const logoUrl = document.getElementById('stripe-data').dataset.logoUrl;
	var handler = StripeCheckout.configure({
		key: pubKey,
		image: logoUrl,
		locale: 'auto',
        name: 'Helpful Village',
        allowRememberMe: true,
        amount: amount,
		token: function(token) {
		      // You can access the token ID with `token.id`.
		      // Get the token ID to your server-side code for use.
              $('#stripeToken').val(token.id);  
              $(submit).get(0).submit();
		}
	});
	return handler;
}

function filter_invoices_table(val) {
    $('#dttb-invoices').DataTable().column( 3 ).search(val).draw();
}


// Auto-pay to-do list: charge an invoice by ACH (the same pay action as the
// invoice page, which also emails the paid invoice) and update its row.
// Resolves with result 'paid', 'already_paid', 'refused' (e.g. no bank
// account), or 'error' when the request failed and the charge may or may not
// have gone through.
function pay_autopay_row($btn) {
    var $row = $btn.closest('tr');
    // Disabled at once so a double click sends a single request.
    $btn.prop('disabled', true).text('Paying...');
    $row.find('.autopay-row-error').remove();
    return new Promise(function(resolve) {
        $.ajax({
            url: $btn.data('url'),
            method: 'POST',
            dataType: 'json',
            data: { payment_method: 'ach' },
            headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
        }).done(function(res) {
            if (res.status === 'paid') {
                $row.find('.autopay-status').text('paid').css('background-color', 'lightgreen');
                $row.find('.autopay-action').text(res.already_paid ? 'Already paid' : 'Paid');
                resolve({ result: res.already_paid ? 'already_paid' : 'paid', emailed: res.emailed, notice: res.notice });
            } else {
                autopay_row_failed($btn, res.notice || 'The payment did not go through.');
                resolve({ result: 'refused', notice: res.notice });
            }
        }).fail(function() {
            autopay_row_failed($btn, 'Request failed: check the invoice page before trying again.');
            resolve({ result: 'error' });
        });
    });
}

function autopay_row_failed($btn, message) {
    $btn.prop('disabled', false).text('Pay (ACH)');
    $btn.after($('<div class="text-danger small autopay-row-error"></div>').text(message));
}

$(document).on('click', '.autopay-pay-ach', function(e) {
    e.preventDefault();
    pay_autopay_row($(this)).then(function(r) {
        if (r.result === 'paid' && r.emailed) {
            show_autopay_notice('success', 'Invoice paid and sent to the customer as paid.');
        } else if (r.result === 'error') {
            show_autopay_notice('danger', 'The payment request failed. Check the invoice page before trying again.');
        } else {
            show_autopay_notice(r.result === 'refused' ? 'danger' : 'warning', r.notice);
        }
    });
});

// Pays the rows still to pay, one at a time from the top, skipping amounts
// flagged in red. Rows paid one by one have lost their button, and rows being
// paid have it disabled, so neither is paid again (the server also refuses an
// invoice that is already paid). Stops if a request fails, since that charge
// may have gone through, or when Stop is pressed (after the current row).
var autopay_stop_requested = false;

$(document).on('click', '#autopay-stop', function(e) {
    e.preventDefault();
    autopay_stop_requested = true;
    $(this).prop('disabled', true).text('Stopping after this one...');
});

$(document).on('click', '#autopay-pay-all', function(e) {
    e.preventDefault();
    var $all = $(this);
    var $open = $('.autopay-pay-ach:enabled');
    var queue = $open.filter(function() { return !$(this).data('flagged'); }).toArray();
    var flagged = $open.length - queue.length;
    if (queue.length === 0) {
        show_autopay_notice('info', 'Nothing to pay' + (flagged ? ': only flagged amounts are left, pay those one by one.' : '.'));
        return;
    }
    var total = queue.reduce(function(sum, btn) { return sum + $(btn).data('amount'); }, 0);
    var question = 'Charge ' + queue.length + ' village(s), ' + autopay_currency(total) + ' total, by ACH?';
    if (flagged) question += ' ' + flagged + ' flagged amount(s) will be skipped.';
    if (!window.confirm(question)) return;

    $all.prop('disabled', true).text('Paying all...');
    autopay_stop_requested = false;
    $('#autopay-stop').prop('disabled', false).text('Stop').show();
    var counts = { paid: 0, not_emailed: 0, already_paid: 0, refused: 0 };

    function next() {
        if (autopay_stop_requested) return finish(null, true);
        var btn = queue.shift();
        if (!btn) return finish(null);
        // Paid one by one, or being paid, since Pay all started.
        if (!document.body.contains(btn) || btn.disabled) return next();
        pay_autopay_row($(btn)).then(function(r) {
            if (r.result === 'error') return finish($(btn).data('village'));
            counts[r.result]++;
            if (r.result === 'paid' && !r.emailed) counts.not_emailed++;
            next();
        });
    }

    function finish(stopped_at, by_user) {
        $all.prop('disabled', false).text('Pay all (ACH)');
        $('#autopay-stop').hide();
        var parts = [counts.paid + ' paid'];
        if (counts.not_emailed) parts.push(counts.not_emailed + ' of them not emailed');
        if (counts.refused) parts.push(counts.refused + ' failed');
        if (counts.already_paid) parts.push(counts.already_paid + ' already paid elsewhere');
        if (flagged) parts.push(flagged + ' skipped (flagged)');
        var summary = parts.join(', ') + '.';
        if (stopped_at) {
            show_autopay_notice('danger', 'Pay all stopped: the payment request for ' + stopped_at +
                ' failed. Check that invoice page before going on. So far: ' + summary);
        } else if (by_user) {
            show_autopay_notice('info', 'Pay all stopped. The rows left were not charged. So far: ' + summary);
        } else {
            var clean = !counts.refused && !counts.not_emailed;
            show_autopay_notice(clean ? 'success' : 'warning', 'Pay all done: ' + summary);
        }
    }

    next();
});

function autopay_currency(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function show_autopay_notice(kind, message) {
    var $alert = $('<div class="alert alert-' + kind + '"></div>').text(message);
    $('#autopay-notice').empty().append($alert);
}
